"use client";

import dynamic from "next/dynamic";
import SquareShimmer from "@/components/ui/shimmerUi/SquareShimmer";

/**
 * Client-only dynamic wrapper around `MarqueeEffect`.
 *
 * `MarqueeEffect` ships Framer Motion + the marquee runtime — heavy for a
 * decorative footer band. Deferring its hydration via `dynamic({ ssr: false })`
 * keeps that runtime out of the initial bundle and reduces TBT. The shimmer
 * preserves the marquee's reserved height to avoid CLS.
 */
const MarqueeEffect = dynamic(() => import("./MarqueeEffect"), {
  ssr: false,
  loading: () => (
    <div className="h-[90px] md:h-[120px] w-full">
      <SquareShimmer />
    </div>
  ),
});

export default MarqueeEffect;
